// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/close.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, #app, .app-container {
  width: 100%;
  min-height: 100%;
  background: white;
}

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: "Roboto", sans-serif;
}

a {
  text-decoration: none;
  color: #56aa1c;
}
a:hover {
  color: rgb(63.8484848485, 126.2121212121, 20.7878787879);
}

.pi-modal {
  display: none;
  position: fixed;
  z-index: 3;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: rgba(0, 0, 0, 0.4);
  animation: fade-in 0.4s;
}
.pi-modal .pi-modal-dialog {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  max-width: 90%;
  max-height: 90%;
  margin: auto;
  background: #fefefe;
  animation: fade-in 0.4s;
}

body.pi-modal-open {
  height: 100vh;
  overflow-y: hidden;
  padding-right: 15px;
  position: fixed;
}
body.pi-modal-open .pi-modal {
  display: block;
}

.text-right {
  text-align: right;
}

.language-picker {
  position: relative;
  margin: 4px 8px 0 0;
}
.language-picker .current {
  cursor: pointer;
}
.language-picker ul {
  display: none;
  background: #f5f5f6;
  border: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  border-radius: 3px 0 3px 3px;
  background-clip: padding-box;
  margin-bottom: 5px;
  position: absolute;
  top: 100%;
  right: 0;
}
.language-picker ul li {
  cursor: pointer;
  border-bottom: 1px solid #ebebeb;
  padding: 10px 20px;
  margin: 0;
  outline: 0;
  color: #7d8086;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.language-picker ul li span {
  padding-left: 8px;
}
.language-picker ul li:hover {
  background: rgba(235, 235, 235, 0.9);
  color: #737881;
}
.language-picker ul.open {
  display: block;
}

.language-icon {
  height: 16px;
  width: 16px;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.app-container {
  flex: 1;
  position: relative;
}

.pi-notifications {
  position: fixed;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  right: 2em;
  bottom: 2em;
}
.pi-notifications .pi-item {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: left;
  padding: 0.8em;
  background-color: white;
  max-width: 500px;
  position: relative;
  box-shadow: 1px 7px 14px -5px rgba(0, 0, 0, 0.2);
}
.pi-notifications .pi-item + .pi-notifications .pi-item {
  margin-top: 1em;
}
.pi-notifications .pi-item.success:before {
  background-color: #2BDE3F;
}
.pi-notifications .pi-item.error:before {
  background-color: #e7431a;
}
.pi-notifications .pi-item.info:before {
  background-color: #1D72F3;
}
.pi-notifications .pi-item.warning:before {
  background-color: #FFC007;
}
.pi-notifications .pi-item:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
}
.pi-notifications .pi-item .pi-details {
  flex: 1;
}
.pi-notifications .pi-item .pi-details .pi-title {
  color: #3e3e3e;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 8px;
}
.pi-notifications .pi-item .pi-details .pi-description {
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 0;
  color: #878787;
}
.pi-notifications .pi-item .pi-close {
  width: 14px;
  cursor: pointer;
  height: 14px;
  fill: #878787;
  margin-left: 1.2em;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
}
@media screen and (max-width: 650px) {
  .pi-notifications {
    right: 0;
    left: 0;
    bottom: 0;
  }
  .pi-notifications .pi-item {
    max-width: 100%;
    width: 100%;
  }
}

.app-container, #app {
  display: flex;
  flex-direction: column;
}

.app-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0 2em;
}

.app-title {
  display: flex;
  position: relative;
  align-items: center;
}

.app-header {
  display: flex;
  flex-direction: row;
  padding: 0 2em;
  margin-bottom: 1em;
  align-items: center;
  justify-content: space-between;
  background: #abcdef;
  position: relative;
  z-index: 2;
}
.app-header h1 {
  white-space: nowrap;
  font-size: 2rem;
}
@media screen and (max-width: 650px) {
  .app-header {
    padding: 0 1em;
  }
  .app-header h1 {
    display: none;
  }
}

.pi-center {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
}

.app-footer {
  font-size: 0.8em;
  padding: 1em 0;
  background: rgb(213.84, 230.5, 247.16);
  display: flex;
  flex-direction: row;
}
.app-footer .pi-menu {
  margin: 0 auto;
  max-width: 1000px;
  column-width: 300px;
  display: block;
}
.app-footer .pi-menu .pi-item {
  display: block;
  padding: 1em 2em;
}

.app-menu {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  padding: 0;
  margin: 0;
  width: 300px;
  max-width: 100%;
  background: rgb(235.26, 243.25, 251.24);
  transform: translateX(-100%);
  transition: all 0.1s ease;
  padding-top: 85px;
  z-index: 1;
}
.app-menu.is-open {
  transform: none;
  box-shadow: 30px 0px 30px -30px rgba(0, 0, 0, 0.2);
}
.app-menu .app-menu-content {
  overflow-y: auto;
  height: 100%;
}
.app-menu .pi-menu {
  display: flex;
  flex-direction: column;
  list-style: none;
}
.app-menu .pi-menu > .pi-item {
  flex: 1;
  margin: 1px 0;
}
.app-menu .pi-menu > .pi-item a {
  display: block;
  border-left: 5px solid #abcdef;
  padding: 1em;
}
.app-menu .pi-menu > .pi-item a:hover {
  border-left-color: rgb(85.32, 154, 222.68);
}

.pi-spinner {
  position: relative;
  width: 50px;
  height: 50px;
  font-size: 0;
}
.pi-spinner:before, .pi-spinner:after {
  content: "";
  display: block;
  position: absolute;
  border-width: 4px;
  border-style: solid;
  border-radius: 50%;
}
@keyframes rotate-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes anti-rotate-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.pi-spinner:before {
  width: 42px;
  height: 42px;
  border-bottom-color: #56aa1c;
  border-right-color: #56aa1c;
  border-top-color: rgba(86, 170, 28, 0);
  border-left-color: rgba(86, 170, 28, 0);
  top: 0;
  left: 0;
  animation: rotate-animation 1s linear 0s infinite;
}
.pi-spinner:after {
  width: 29.4px;
  height: 29.4px;
  border-bottom-color: #56aa1c;
  border-right-color: #56aa1c;
  border-top-color: rgba(86, 170, 28, 0);
  border-left-color: rgba(86, 170, 28, 0);
  top: 6.3px;
  left: 6.3px;
  animation: anti-rotate-animation 0.85s linear 0s infinite;
}

.pi-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.pi-dashboard {
  flex: 1;
  position: relative;
  display: grid;
  grid-template-columns: repeat(auto-fit, 70px);
  grid-template-rows: repeat(auto-fit, 70px);
  grid-gap: 10px;
  overflow: visible;
}
.pi-dashboard .pi-tile {
  display: flex;
  position: relative;
}
.pi-dashboard .pi-tile.small {
  grid-column: span 1;
  grid-row: span 1;
  width: 70px;
  height: 70px;
}
.pi-dashboard .pi-tile.medium {
  grid-column: span 2;
  grid-row: span 2;
  width: 150px;
  height: 150px;
}
.pi-dashboard .pi-tile.wide {
  grid-column: span 4;
  grid-row: span 2;
  width: 310px;
  height: 150px;
}
.pi-dashboard .pi-tile.large {
  grid-column: span 4;
  grid-row: span 4;
  width: 310px;
  height: 310px;
}
.pi-dashboard .pi-tile:hover {
  outline: rgba(29, 29, 29, 0.1) solid 4px;
}

.pi-search {
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
}
.pi-search input[type=search] {
  font-size: 1em;
  border: 1px solid transparent;
  background-color: #f1f1f1;
  padding: 10px;
  font-size: 16px;
  max-width: 80%;
  width: 250px;
  box-sizing: border-box;
  transition: width ease 0.1s;
}
@media screen and (max-width: 450px) {
  .pi-search input[type=search] {
    width: 100px;
  }
}
.pi-search:focus-within input[type=search] {
  width: 90%;
  max-width: 90%;
}
.pi-search:focus-within input[type=search] + .pi-details:not(:empty) {
  display: block;
  opacity: 1;
}
.pi-search .pi-details {
  display: none;
  opacity: 0;
  position: absolute;
  z-index: 2;
  top: 100%;
  width: 90%;
  box-sizing: border-box;
  background: #f0f0f0;
  padding: 1px;
  transition: all 0.1s 0.1s ease;
}
.pi-search .pi-item {
  display: block;
  padding: 10px;
  cursor: pointer;
  background-color: white;
  border-bottom: 1px solid #d4d4d4;
}
.pi-search .pi-item:hover {
  background-color: #e9e9e9;
}
.pi-search .pi-center {
  padding: 30px;
  background-color: white;
}

.form-row {
  margin: 1em;
}
.form-row label {
  display: block;
  margin-bottom: 0.2em;
}
.form-row input {
  padding: 0.3rem;
  font-size: 1rem;
}
.form-row button {
  padding: 0.5em 1em;
  border: 1px solid black;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
}
.form-row button:disabled {
  border: 1px solid #ccc;
  color: #ccc;
  cursor: default;
}

.pi-error > img {
  width: 600px;
  max-width: 100%;
  margin: 1em 0;
}
.pi-error .pi-title {
  color: #56aa1c;
  display: block;
  font-size: 1.5em;
}
.pi-error .pi-description {
  display: block;
  margin: 0.5em 0;
}
.pi-error .pi-details {
  display: block;
  margin: 0.5em 0;
  color: #3e3e3e;
  font-size: 0.8em;
}

.app-user {
  position: relative;
}
.app-user .app-user-avatar {
  display: flex;
  align-items: center;
  white-space: nowrap;
  cursor: pointer;
}
.app-user .app-user-avatar img {
  position: relative;
  overflow: hidden;
  width: 32px;
  min-width: 32px;
  height: 32px;
  border-radius: 50% !important;
  vertical-align: middle;
  border-style: none;
  box-sizing: border-box;
  line-height: 1;
  margin-right: 0.5em;
}
.app-user .app-user-avatar::after {
  display: inline-block;
  box-sizing: border-box;
  height: 8px;
  width: 8px;
  border-style: solid;
  border-color: black;
  border-width: 0px 2px 2px 0px;
  position: relative;
  transform: rotate(45deg);
  transition: opacity 150ms ease-in-out;
  content: "";
}
.app-user .app-user-details {
  display: none;
  list-style: none;
  position: absolute;
  background: white;
  padding: 0;
  right: 0;
  border: 1px solid #ececec;
  border-radius: 3px;
  top: 40px;
  cursor: default;
}
.app-user .app-user-details li {
  display: block;
  padding: 10px;
  max-width: 300px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: right;
}
.app-user .app-user-details li > a {
  display: block;
}
.app-user .app-user-details li.sep {
  border-bottom: 1px solid #ccc;
  padding: 0;
}
.app-user .app-user-details li .user-name {
  font-weight: bold;
  color: #666;
  display: block;
  font-size: 0.6em;
}
.app-user .app-user-details:before, .app-user .app-user-details:after {
  content: "";
  display: block;
  position: absolute;
  bottom: 100%;
  width: 0;
  height: 0;
}
.app-user .app-user-details:before {
  right: 27px;
  border: 6px solid transparent;
  border-bottom-color: #ececec;
}
.app-user .app-user-details:after {
  right: 28px;
  border: 5px solid transparent;
  border-bottom-color: #fff;
}
.app-user.is-open img {
  opacity: 0.8;
}
.app-user.is-open .app-user-details {
  display: block;
}
.app-user.is-open::after {
  opacity: 0.2;
}

.hamburger {
  padding: 15px 0;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible;
  transform: scale(0.6);
}
.hamburger:hover {
  opacity: 0.7;
}
.hamburger.is-active:hover {
  opacity: 0.7;
}
.hamburger.is-active .hamburger-inner,
.hamburger.is-active .hamburger-inner::before,
.hamburger.is-active .hamburger-inner::after {
  background-color: #000;
}

.hamburger-box {
  width: 40px;
  height: 24px;
  display: inline-block;
  position: relative;
}

.hamburger-inner {
  display: block;
  top: 50%;
  margin-top: -2px;
}
.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
  width: 40px;
  height: 4px;
  background-color: #000;
  border-radius: 4px;
  position: absolute;
  transition-property: transform;
  transition-duration: 0.15s;
  transition-timing-function: ease;
}
.hamburger-inner::before, .hamburger-inner::after {
  content: "";
  display: block;
}
.hamburger-inner::before {
  top: -10px;
}
.hamburger-inner::after {
  bottom: -10px;
}

.hamburger--arrow.is-active .hamburger-inner::before {
  transform: translate3d(-8px, 0, 0) rotate(-45deg) scale(0.7, 1);
}
.hamburger--arrow.is-active .hamburger-inner::after {
  transform: translate3d(-8px, 0, 0) rotate(45deg) scale(0.7, 1);
}`, "",{"version":3,"sources":["webpack://./src/styles/_layout.scss","webpack://./src/styles/index.scss","webpack://./src/styles/_burger.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,gBAAA;EACA,iBCLS;AAIX;;ADIA;EACE,YAAA;EACA,SAAA;EACA,UAAA;EACA,iCAAA;ACDF;;ADIA;EACE,qBAAA;EACA,cChBiB;AAenB;ADGE;EACE,wDAAA;ACDJ;;ADKA;EACE,aAAA;EACA,eAAA;EACA,UAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,8BAAA;EACA,uBAAA;ACFF;ADIE;EACE,eAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;ACFJ;;ADMA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ACHF;ADKE;EACE,cAAA;ACHJ;;ADOA;EACE,iBAAA;ACJF;;ADOA;EACE,kBAAA;EACA,mBAAA;ACJF;ADME;EACE,eAAA;ACJJ;ADOE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,4BAAA;EACA,4BAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;ACLJ;ADOI;EACE,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;ACLN;ADOM;EACE,iBAAA;ACLR;ADQM;EACE,oCAAA;EACA,cAAA;ACNR;ADUI;EACE,cAAA;ACRN;;ADaA;EACE,YAAA;EACA,WAAA;ACVF;;ADaA;EACE;IACE,UAAA;ECVF;EDYA;IACE,UAAA;ECVF;AACF;ADaA;EACE,OAAA;EACA,kBAAA;ACXF;;ADcA;EACE,eAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,UAAA;EACA,WAAA;ACXF;ADaE;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBCpJO;EDqJP,gBAAA;EACA,kBAAA;EACA,gDAAA;ACXJ;ADaI;EACE,eAAA;ACXN;ADcI;EACE,yBAAA;ACZN;ADeI;EACE,yBAAA;ACbN;ADgBI;EACE,yBAAA;ACdN;ADiBI;EACE,yBAAA;ACfN;ADkBI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;AChBN;ADmBI;EACE,OAAA;ACjBN;ADmBM;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;ACjBR;ADoBM;EACE,eAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;AClBR;ADsBI;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,2EAAA;ACpBN;ADwBE;EA7EF;IA8EI,QAAA;IACA,OAAA;IACA,SAAA;ECrBF;EDuBE;IACE,eAAA;IACA,WAAA;ECrBJ;AACF;;ADyBA;EACE,aAAA;EACA,sBAAA;ACtBF;;ADyBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;ACtBF;;ADyBA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;ACtBF;;ADyBA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBCrPa;EDsPb,kBAAA;EACA,UAAA;ACtBF;ADwBE;EACE,mBAAA;EACA,eAAA;ACtBJ;ADyBE;EAhBF;IAiBI,cAAA;ECtBF;EDwBE;IACE,aAAA;ECtBJ;AACF;;AD0BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;ACvBF;;AD0BA;EACE,gBAAA;EACA,cAAA;EACA,sCChRa;EDiRb,aAAA;EACA,mBAAA;ACvBF;ADyBE;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;ACvBJ;ADyBI;EACE,cAAA;EACA,gBAAA;ACvBN;;AD4BA;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,uCAAA;EACA,4BAAA;EACA,yBAAA;EACA,iBAAA;EACA,UAAA;ACzBF;AD2BE;EACE,eAAA;EACA,kDAAA;ACzBJ;AD4BE;EACE,gBAAA;EACA,YAAA;AC1BJ;AD6BE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AC3BJ;AD6BI;EACE,OAAA;EACA,aAAA;AC3BN;AD6BM;EACE,cAAA;EACA,8BAAA;EACA,YAAA;AC3BR;AD6BQ;EACE,0CCxUG;AA6Sb;;ADkCA;EACE,kBAAA;EACA,WC/UyB;EDgVzB,YChVyB;EDiVzB,YAAA;AC/BF;ADiCE;EAEE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AChCJ;ADmCE;EACE;IACE,uBAAA;ECjCJ;EDoCE;IACE,yBAAA;EClCJ;AACF;ADqCE;EACE;IACE,uBAAA;ECnCJ;EDsCE;IACE,0BAAA;ECpCJ;AACF;ADuCE;EACE,WCjXsB;EDkXtB,YClXsB;EDmXtB,4BCzXe;ED0Xf,2BC1Xe;ED2Xf,sCAAA;EACA,uCAAA;EACA,MAAA;EACA,OAAA;EACA,iDAAA;ACrCJ;ADwCE;EACE,aC5XuB;ED6XvB,cC7XuB;ED8XvB,4BCrYe;EDsYf,2BCtYe;EDuYf,sCAAA;EACA,uCAAA;EACA,UAAA;EACA,WAAA;EACA,yDAAA;ACtCJ;;AD8CA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;AC3CF;;AD8CA;EACE,OAAA;EACA,kBAAA;EACA,aAAA;EACA,6CAAA;EACA,0CAAA;EACA,cAdS;EAeT,iBAAA;AC3CF;AD6CE;EACE,aAAA;EACA,kBAAA;AC3CJ;AD6CI;EACE,mBAAA;EACA,gBAAA;EACA,WAzBO;EA0BP,YA3BQ;AChBd;AD8CI;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AC5CN;AD+CI;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AC7CN;ADgDI;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AC9CN;ADiDI;EACE,wCAAA;AC/CN;;ADoDA;EACE,kBAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;ACjDF;ADmDE;EACE,cAAA;EACA,6BAAA;EACA,yBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;ACjDJ;ADmDI;EAXF;IAYI,YAAA;EChDJ;AACF;ADmDE;EACE,UAAA;EACA,cAAA;ACjDJ;ADmDI;EACE,cAAA;EACA,UAAA;ACjDN;ADqDE;EACE,aAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,8BAAA;ACnDJ;ADsDE;EACE,cAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,gCAAA;ACpDJ;ADuDE;EACE,yBAAA;ACrDJ;ADwDE;EACE,aAAA;EACA,uBAAA;ACtDJ;;AD0DA;EACE,WAAA;ACvDF;ADyDE;EACE,cAAA;EACA,oBAAA;ACvDJ;AD0DE;EACE,eAAA;EACA,eAAA;ACxDJ;AD2DE;EACE,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;ACzDJ;AD4DE;EACE,sBAAA;EACA,WAAA;EACA,eAAA;AC1DJ;;AD+DE;EACE,YAAA;EACA,eAAA;EACA,aAAA;AC5DJ;AD+DE;EACE,cC3iBe;ED4iBf,cAAA;EACA,gBAAA;AC7DJ;ADgEE;EACE,cAAA;EACA,eAAA;AC9DJ;ADiEE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AC/DJ;;ADmEA;EACE,kBAAA;AChEF;ADkEE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AChEJ;ADkEI;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;AChEN;ADmEI;EACE,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,wBAAA;EACA,qCAAA;EACA,WAAA;ACjEN;ADqEE;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,QAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;ACnEJ;ADqEI;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;ACnEN;ADqEM;EACE,cAAA;ACnER;ADsEM;EACE,6BAAA;EACA,UAAA;ACpER;ADuEM;EACE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;ACrER;ADyEI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;ACvEN;AD0EI;EACE,WAAA;EACA,6BAAA;EACA,4BAAA;ACxEN;AD2EI;EACE,WAAA;EACA,6BAAA;EACA,yBAAA;ACzEN;AD8EI;EACE,YAAA;AC5EN;AD+EI;EACE,cAAA;AC7EN;ADgFI;EACE,YAAA;AC9EN;;AC1lBA;EACE,eDQkB;ECPlB,qBAAA;EACA,eAAA;EAEA,oCAAA;EACA,0BAAA;EACA,kCAAA;EAGA,aAAA;EACA,cAAA;EACA,oBAAA;EACA,6BAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,qBAAA;AD0lBF;ACxlBE;EAKI,YDToB;AA+lB1B;ACjlBI;EAKI,YDnBkB;AAkmB1B;AC3kBI;;;EAGE,sBD5BkB;AAymBxB;;ACxkBA;EACE,WDrCsB;ECsCtB,YAAA;EACA,qBAAA;EACA,kBAAA;AD2kBF;;ACxkBA;EACE,cAAA;EACA,QAAA;EACA,gBAAA;AD2kBF;ACzkBE;EAGE,WDnDoB;ECoDpB,WDnDqB;ECoDrB,sBDlDoB;ECmDpB,kBDlD4B;ECmD5B,kBAAA;EACA,8BAAA;EACA,0BAAA;EACA,gCAAA;ADykBJ;ACtkBE;EAEE,WAAA;EACA,cAAA;ADukBJ;ACpkBE;EACE,UAAA;ADskBJ;ACnkBE;EACE,aAAA;ADqkBJ;;AC/jBI;EACE,+DAAA;ADkkBN;AC/jBI;EACE,8DAAA;ADikBN","sourcesContent":["@use 'sass:math';\n\nhtml, body, #app, .app-container {\n  width: 100%;\n  min-height: 100%;\n  background: $bg-color;\n}\n\nhtml, body {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  font-family: 'Roboto', sans-serif;\n}\n\na {\n  text-decoration: none;\n  color: $basic-dark-color;\n\n  &:hover {\n    color: darken($color: $basic-dark-color, $amount: 10%)\n  }\n}\n\n.pi-modal {\n  display: none;\n  position: fixed;\n  z-index: 3;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background: rgba(0, 0, 0, 0.4);\n  animation: fade-in 0.4s;\n\n  .pi-modal-dialog {\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    max-width: 90%;\n    max-height: 90%;\n    margin: auto;\n    background: #fefefe;\n    animation: fade-in 0.4s;\n  }\n}\n\nbody.pi-modal-open {\n  height: 100vh;\n  overflow-y: hidden;\n  padding-right: 15px;\n  position: fixed;\n\n  .pi-modal {\n    display: block;\n  }\n}\n\n.text-right {\n  text-align: right;\n}\n\n.language-picker {\n  position: relative;\n  margin: 4px 8px 0 0;\n\n  .current {\n    cursor: pointer;\n  }\n\n  ul {\n    display: none;\n    background: #f5f5f6;\n    border: none;\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n    border-radius: 3px 0 3px 3px;\n    background-clip: padding-box;\n    margin-bottom: 5px;\n    position: absolute;\n    top: 100%;\n    right: 0;\n\n    li {\n      cursor: pointer;\n      border-bottom: 1px solid #ebebeb;\n      padding: 10px 20px;\n      margin: 0;\n      outline: 0;\n      color: #7d8086;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n\n      span {\n        padding-left: 8px;\n      }\n\n      &:hover {\n        background: rgba(235, 235, 235, 0.9);\n        color: #737881;\n      }\n    }\n\n    &.open {\n      display: block;\n    }\n  }\n}\n\n.language-icon {\n  height: 16px;\n  width: 16px;\n}\n\n@keyframes fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.app-container {\n  flex: 1;\n  position: relative;\n}\n\n.pi-notifications {\n  position: fixed;\n  display: flex;\n  align-items: flex-end;\n  flex-direction: column;\n  right: 2em;\n  bottom: 2em;\n\n  .pi-item {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    text-align: left;\n    padding: 0.8em;\n    background-color: $bg-color;\n    max-width: 500px;\n    position: relative;\n    box-shadow: 1px 7px 14px -5px rgba(0,0,0,0.2);\n\n    &+& {\n      margin-top: 1em;\n    }\n\n    &.success:before {\n      background-color: #2BDE3F;\n    }\n\n    &.error:before {\n      background-color: #e7431a;\n    }\n\n    &.info:before {\n      background-color: #1D72F3;\n    }\n\n    &.warning:before {\n      background-color: #FFC007;\n    }\n\n    &:before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 2px;\n    }\n\n    .pi-details {\n      flex: 1;\n\n      .pi-title {\n        color: #3e3e3e;\n        font-weight: 700;\n        margin-top: 0;\n        margin-bottom: 8px;\n      }\n\n      .pi-description {\n        font-size: 14px;\n        margin-top: 0;\n        margin-bottom: 0;\n        color: #878787;\n      }\n    }\n\n    .pi-close {\n      width: 14px;\n      cursor: pointer;\n      height: 14px;\n      fill: #878787;\n      margin-left: 1.2em;\n      background: url('../images/close.svg') no-repeat center center;\n    }\n  }\n\n  @media screen and (max-width: $breakpoint-tablet) {\n    right: 0;\n    left: 0;\n    bottom: 0;\n\n    .pi-item {\n      max-width: 100%;\n      width: 100%;\n    }\n  }\n}\n\n.app-container, #app {\n  display: flex;\n  flex-direction: column;\n}\n\n.app-content {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding: 0 2em;\n}\n\n.app-title {\n  display: flex;\n  position: relative;\n  align-items: center;\n}\n\n.app-header {\n  display: flex;\n  flex-direction: row;\n  padding: 0 2em;\n  margin-bottom: 1em;\n  align-items: center;\n  justify-content: space-between;\n  background: $header-color;\n  position: relative;\n  z-index: 2;\n\n  h1 {\n    white-space: nowrap;\n    font-size: 2rem;\n  }\n\n  @media screen and (max-width: $breakpoint-tablet) {\n    padding: 0 1em;\n\n    h1 {\n      display: none;\n    }\n  }\n}\n\n.pi-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-grow: 1;\n}\n\n.app-footer {\n  font-size: 0.8em;\n  padding: 1em 0;\n  background: $footer-color;\n  display: flex;\n  flex-direction: row;\n\n  .pi-menu {\n    margin: 0 auto;\n    max-width: 1000px;\n    column-width: 300px;\n    display: block;\n\n    .pi-item {\n      display: block;\n      padding: 1em 2em;\n    }\n  }\n}\n\n.app-menu {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  padding: 0;\n  margin: 0;\n  width: 300px;\n  max-width: 100%;\n  background: lighten($header-color, 15%);\n  transform: translateX(-100%);\n  transition: all 0.1s ease;\n  padding-top: 85px;\n  z-index: 1;\n\n  &.is-open {\n    transform: none;\n    box-shadow: $menu-shadow-size 0px $menu-shadow-size (-$menu-shadow-size) rgba(0, 0, 0, 0.2);\n  }\n\n  .app-menu-content {\n    overflow-y: auto;\n    height: 100%;\n  }\n\n  .pi-menu {\n    display: flex;\n    flex-direction: column;\n    list-style: none;\n\n    > .pi-item {\n      flex: 1;\n      margin: 1px 0;\n\n      a {\n        display: block;\n        border-left: 5px solid $header-color;\n        padding: 1em;\n\n        &:hover {\n          border-left-color: $menu-color;\n        }\n      }\n    }\n  }\n}\n\n.pi-spinner {\n  position: relative;\n  width: $basic-spinner-dimensions;\n  height: $basic-spinner-dimensions;\n  font-size: 0;\n\n  &:before,\n  &:after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    border-width: 4px;\n    border-style: solid;\n    border-radius: 50%;\n  }\n\n  @keyframes rotate-animation {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes anti-rotate-animation {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(-360deg);\n    }\n  }\n\n  &:before {\n    width: $main-spinner-dimensions;\n    height: $main-spinner-dimensions;\n    border-bottom-color: $basic-dark-color;\n    border-right-color: $basic-dark-color;\n    border-top-color: rgba($basic-dark-color, 0);\n    border-left-color: rgba($basic-dark-color, 0);\n    top: 0;\n    left: 0;\n    animation: rotate-animation 1s linear 0s infinite;\n  }\n\n  &:after {\n    width: $small-spinner-dimensions;\n    height: $small-spinner-dimensions;\n    border-bottom-color: $basic-dark-color;\n    border-right-color: $basic-dark-color;\n    border-top-color: rgba($basic-dark-color, 0);\n    border-left-color: rgba($basic-dark-color, 0);\n    top: math.div($main-spinner-dimensions - $small-spinner-dimensions, 2);\n    left: math.div($main-spinner-dimensions - $small-spinner-dimensions, 2);\n    animation: anti-rotate-animation 0.85s linear 0s infinite;\n  }\n}\n\n$tile-height: 70px;\n$tile-width: 70px;\n$tile-gap: 10px;\n\n.pi-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.pi-dashboard {\n  flex: 1;\n  position: relative;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, $tile-width);\n  grid-template-rows: repeat(auto-fit, $tile-height);\n  grid-gap: $tile-gap;\n  overflow: visible;\n\n  .pi-tile {\n    display: flex;\n    position: relative;\n\n    &.small {\n      grid-column: span 1;\n      grid-row: span 1;\n      width: $tile-width;\n      height: $tile-height;\n    }\n\n    &.medium {\n      grid-column: span 2;\n      grid-row: span 2;\n      width: 2 * $tile-width + 1 * $tile-gap;\n      height: 2 * $tile-height + 1 * $tile-gap;\n    }\n\n    &.wide {\n      grid-column: span 4;\n      grid-row: span 2;\n      width: 4 * $tile-width + 3 * $tile-gap;\n      height: 2 * $tile-height + 1 * $tile-gap;\n    }\n\n    &.large {\n      grid-column: span 4;\n      grid-row: span 4;\n      width: 4 * $tile-width + 3 * $tile-gap;\n      height: 4 * $tile-height + 3 * $tile-gap;\n    }\n\n    &:hover {\n      outline: rgba(29, 29, 29, 0.1) solid 4px;\n    }\n  }\n}\n\n.pi-search {\n  position: relative;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n\n  input[type=search] {\n    font-size: 1em;\n    border: 1px solid transparent;\n    background-color: #f1f1f1;\n    padding: 10px;\n    font-size: 16px;\n    max-width: 80%;\n    width: 250px;\n    box-sizing: border-box;\n    transition: width ease 0.1s;\n\n    @media screen and (max-width: $breakpoint-mobile) {\n      width: 100px;\n    }\n  }\n\n  &:focus-within input[type=search] {\n    width: 90%;\n    max-width: 90%;\n\n    & + .pi-details:not(:empty) {\n      display: block;\n      opacity: 1;\n    }\n  }\n\n  .pi-details {\n    display: none;\n    opacity: 0;\n    position: absolute;\n    z-index: 2;\n    top: 100%;\n    width: 90%;\n    box-sizing: border-box;\n    background: #f0f0f0;\n    padding: 1px;\n    transition: all 0.1s 0.1s ease;\n  }\n\n  .pi-item {\n    display: block;\n    padding: 10px;\n    cursor: pointer;\n    background-color: white;\n    border-bottom: 1px solid #d4d4d4;\n  }\n\n  .pi-item:hover {\n    background-color: #e9e9e9;\n  }\n\n  .pi-center {\n    padding: 30px;\n    background-color: white;\n  }\n}\n\n.form-row {\n  margin: 1em;\n\n  label {\n    display: block;\n    margin-bottom: 0.2em;\n  }\n\n  input {\n    padding: 0.3rem;\n    font-size: 1rem;\n  }\n\n  button {\n    padding: 0.5em 1em;\n    border: 1px solid black;\n    font-weight: bold;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n\n  button:disabled {\n    border: 1px solid #ccc;\n    color: #ccc;\n    cursor: default;\n  }\n}\n\n.pi-error {\n  > img {\n    width: 600px;\n    max-width: 100%;\n    margin: 1em 0;\n  }\n\n  .pi-title {\n    color: $basic-dark-color;\n    display: block;\n    font-size: 1.5em;\n  }\n\n  .pi-description {\n    display: block;\n    margin: 0.5em 0;\n  }\n\n  .pi-details {\n    display: block;\n    margin: 0.5em 0;\n    color: #3e3e3e;\n    font-size: 0.8em;\n  }\n}\n\n.app-user {\n  position: relative;\n\n  .app-user-avatar {\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    cursor: pointer;\n\n    img {\n      position: relative;\n      overflow: hidden;\n      width: 32px;\n      min-width: 32px;\n      height: 32px;\n      border-radius: 50% !important;\n      vertical-align: middle;\n      border-style: none;\n      box-sizing: border-box;\n      line-height: 1;\n      margin-right: 0.5em;\n    }\n\n    &::after {\n      display: inline-block;\n      box-sizing: border-box;\n      height: 8px;\n      width: 8px;\n      border-style: solid;\n      border-color: black;\n      border-width: 0px 2px 2px 0px;\n      position: relative;\n      transform: rotate(45deg);\n      transition: opacity 150ms ease-in-out;\n      content: '';\n    }\n  }\n\n  .app-user-details {\n    display: none;\n    list-style: none;\n    position: absolute;\n    background: white;\n    padding: 0;\n    right: 0;\n    border: 1px solid #ececec;\n    border-radius: 3px;\n    top: 40px;\n    cursor: default;\n\n    li {\n      display: block;\n      padding: 10px;\n      max-width: 300px;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n      text-align: right;\n\n      & > a {\n        display: block;\n      }\n\n      &.sep {\n        border-bottom: 1px solid #ccc;\n        padding: 0;\n      }\n\n      .user-name {\n        font-weight: bold;\n        color: #666;\n        display: block;\n        font-size: 0.6em;\n      }\n    }\n\n    &:before, &:after {\n      content: '';\n      display: block;\n      position: absolute;\n      bottom: 100%;\n      width: 0;\n      height: 0;\n    }\n\n    &:before {\n      right: 27px;\n      border: 6px solid transparent;\n      border-bottom-color: #ececec;\n    }\n\n    &:after {\n      right: 28px;\n      border: 5px solid transparent;\n      border-bottom-color: #fff;\n    }\n  }\n\n  &.is-open {\n    img {\n      opacity: 0.8;\n    }\n\n    .app-user-details {\n      display: block;\n    }\n\n    &::after {\n      opacity: 0.2;\n    }\n  }\n}\n","$bg-color: white;\n$basic-dark-color: #56aa1c;\n$header-color: #abcdef;\n$footer-color: lighten($header-color, 10%);\n$menu-color: darken($header-color, 20%);\n$border-width: 4px;\n$basic-spinner-dimensions: 50px;\n$main-spinner-dimensions: $basic-spinner-dimensions - $border-width * 2;\n$small-spinner-dimensions: $main-spinner-dimensions * 0.7;\n$menu-shadow-size: 30px;\n\n$hamburger-padding: 15px 0 !default;\n$hamburger-layer-width: 40px !default;\n$hamburger-layer-height: 4px !default;\n$hamburger-layer-spacing: 6px !default;\n$hamburger-layer-color: #000 !default;\n$hamburger-layer-border-radius: 4px !default;\n$hamburger-hover-opacity: 0.7 !default;\n$hamburger-active-layer-color: $hamburger-layer-color !default;\n$hamburger-active-hover-opacity: $hamburger-hover-opacity !default;\n$hamburger-hover-use-filter: false !default;\n$hamburger-hover-filter: opacity(50%) !default;\n$hamburger-active-hover-filter: $hamburger-hover-filter !default;\n\n$breakpoint-mobile: 450px;\n$breakpoint-tablet: 650px;\n\n@import './layout';\n@import './burger';\n","@use 'sass:math';\n\n.hamburger {\n  padding: $hamburger-padding;\n  display: inline-block;\n  cursor: pointer;\n\n  transition-property: opacity, filter;\n  transition-duration: 0.15s;\n  transition-timing-function: linear;\n\n  // Normalize (<button>)\n  font: inherit;\n  color: inherit;\n  text-transform: none;\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n  overflow: visible;\n  transform: scale(0.6);\n\n  &:hover {\n    @if $hamburger-hover-use-filter == true {\n      filter: $hamburger-hover-filter;\n    }\n    @else {\n      opacity: $hamburger-hover-opacity;\n    }\n  }\n\n  &.is-active {\n    &:hover {\n      @if $hamburger-hover-use-filter == true {\n        filter: $hamburger-active-hover-filter;\n      }\n      @else {\n        opacity: $hamburger-active-hover-opacity;\n      }\n    }\n\n    .hamburger-inner,\n    .hamburger-inner::before,\n    .hamburger-inner::after {\n      background-color: $hamburger-active-layer-color;\n    }\n  }\n}\n\n.hamburger-box {\n  width: $hamburger-layer-width;\n  height: $hamburger-layer-height * 3 + $hamburger-layer-spacing * 2;\n  display: inline-block;\n  position: relative;\n}\n\n.hamburger-inner {\n  display: block;\n  top: 50%;\n  margin-top: math.div($hamburger-layer-height, -2);\n\n  &,\n  &::before,\n  &::after {\n    width: $hamburger-layer-width;\n    height: $hamburger-layer-height;\n    background-color: $hamburger-layer-color;\n    border-radius: $hamburger-layer-border-radius;\n    position: absolute;\n    transition-property: transform;\n    transition-duration: 0.15s;\n    transition-timing-function: ease;\n  }\n\n  &::before,\n  &::after {\n    content: \"\";\n    display: block;\n  }\n\n  &::before {\n    top: ($hamburger-layer-spacing + $hamburger-layer-height) * -1;\n  }\n\n  &::after {\n    bottom: ($hamburger-layer-spacing + $hamburger-layer-height) * -1;\n  }\n}\n\n.hamburger--arrow.is-active {\n  .hamburger-inner {\n    &::before {\n      transform: translate3d($hamburger-layer-width * -0.2, 0, 0) rotate(-45deg) scale(0.7, 1);\n    }\n\n    &::after {\n      transform: translate3d($hamburger-layer-width * -0.2, 0, 0) rotate(45deg) scale(0.7, 1);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
